const getters = {
  uid: state => state.user.uid,
  name: state => state.user.name,
  avatar: state => state.user.avatar,
  hasRole: state => state.user.hasRole,
  promotorType: state => state.user.promotorType,
  accountState: state => state.user.accountState,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  isPromotorDisplay: state => state.user.isPromotorDisplay,

  //测试，线上路径相关
  FILE_UPLOAD_PATH: state => state.config.FILE_UPLOAD_PATH,
  FILE_UPLOAD_TOEKN: state => state.config.FILE_UPLOAD_TOEKN,
  SUB_SITE_HOST: state => state.config.SUBSITE_HOST,
  SUB_PREVIEW_ID: state => state.config.SUB_PREVIEW_ID,
  PROTOCOL: state => state.config.PROTOCOL,
  HOST: state => state.config.HOST,
  AVATAR_LINK: state => state.config.AVATAR_LINK
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js